import React from 'react'
import { Grid, Box, Link } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { modificationTypeValue } from './ModificationResponse'
import { configContext } from '../../utils/StandardReducer'
import { TubeProduct } from '../../utils/enum'
import globalStyles from '@src/routes/Configurators/utils/styles'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import clsx from 'clsx'

const InitialValues = {
  DEGENERATED_BASES: 'degenerateBases',
  LNA_BASES: 'LNA Bases',
  DNA_BASES: 'DNA Bases',
  RNA_DEGENERATE_BASE: 'RNA Degenerate Bases',
  STANDARD_DEGENERATE_BASES: 'Standard Degenerate Bases',
  URACIL_AND_INOSINE: 'Uracil and Inosine',
  TWO_OME_RNA_BASE: '2-OMe RNA Bases',
  TWO_FLUORO_BASES: '2 Fluoro Bases',
  MODIFIED_BASES: 'Modified Bases',
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    lead: {
      fontSize: theme.typography.pxToRem(12),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(3, 0),
    },
    add: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    addDisabled: {
      color: theme.palette.grey[500],
      fontWeight: theme.typography.fontWeightMedium,
      cursor: 'not-allowed',
    },
  }
})

const OptionalBases = (props) => {
  const classes = useStyles()
  const globalClasses = globalStyles()
  const { modificationResponseData, productType } = props
  const { state, dispatch } = React.useContext(configContext)
  const isLNABaseEnable =
    state.sessionData[props.currentOligoIndex].isLNABaseEnable

  const baseValueHandlerChange = (event, base) => {
    if (
      productType === TubeProduct.Standard ||
      productType === TubeProduct.Rna ||
      TubeProduct.Probe
    ) {
      dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: true })
      dispatch({ type: 'UPDATE_OPTIONAL_BASES', data: base })
      dispatch({ type: 'OPTIONAL_BASES_CHANGED', data: true })
      dispatch({
        type: 'IS_CONFIRM_ORDER',
        data: false,
      })
    }
  }

  const baseValues = (categoryType: string, categoryValue: string) => {
    const baseValues: any[] = []
    modificationTypeValue(
      categoryType,
      categoryValue,
      modificationResponseData,
      isLNABaseEnable
    ).forEach((base, index) => {
      baseValues.push(
        <Grid container key={index} alignItems="flex-start">
          <Grid item xs={12} sm={6}>
            <div>
              {
                <FormattedMessage
                  {...checkValidKey(messages[base.label], base.label)}
                />
              }
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div>
              <Link
                component="button"
                className={base?.disabled ? classes.addDisabled : classes.add}
                onClick={(e) => baseValueHandlerChange(e, base.value)}
                disabled={base?.disabled}
              >
                <FormattedMessage {...messages.CONF_ADD_BUTTON} />
              </Link>
            </div>
          </Grid>
        </Grid>
      )
    })
    return baseValues
  }
  const lnaBases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.LNA_BASES
  )
  const DNABases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.DNA_BASES
  )
  const RnaDegenerateBases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.RNA_DEGENERATE_BASE
  )
  const StandardDegenerateBases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.STANDARD_DEGENERATE_BASES
  )
  const uracilAndInosine = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.URACIL_AND_INOSINE
  )
  const TwoOMeRNABases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.TWO_OME_RNA_BASE
  )
  const twoFluoroBases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.TWO_FLUORO_BASES
  )
  const modifiedBases = baseValues(
    InitialValues.DEGENERATED_BASES,
    InitialValues.MODIFIED_BASES
  )
  return (
    <>
      <Box
        component="p"
        className={clsx(classes.lead, globalClasses.globalHelpTextColor)}
      >
        <FormattedMessage {...messages.CONF_OPTIONAL_BASES_HEADER_standard} />
      </Box>
      <Grid container>
        {productType === TubeProduct.iscaledna ? (
          <>
            {StandardDegenerateBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_DNA_DEGENERATE_BASES} />
                </h4>
                {StandardDegenerateBases}
              </Grid>
            ) : (
              ''
            )}
            {TwoOMeRNABases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_OME_RNA_BASES} />
                </h4>
                {TwoOMeRNABases}
              </Grid>
            ) : (
              ''
            )}
            {uracilAndInosine.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_URACLI_INOSINE} />
                </h4>
                {uracilAndInosine}
              </Grid>
            ) : (
              ''
            )}

            {lnaBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_LNA_BASES} />
                </h4>
                {lnaBases}
              </Grid>
            ) : (
              ''
            )}

            {modifiedBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_MODIFIED_BASES} />
                </h4>
                {modifiedBases}
              </Grid>
            ) : (
              ''
            )}

            {DNABases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_DNA_BASES} />
                </h4>
                {DNABases}
              </Grid>
            ) : (
              ''
            )}

            {RnaDegenerateBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_RNA_DEGENERATE_BASES} />
                </h4>
                {RnaDegenerateBases}
              </Grid>
            ) : (
              ''
            )}
            {twoFluoroBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_FLUORO_BASES} />
                </h4>
                {twoFluoroBases}
              </Grid>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            {StandardDegenerateBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_DNA_DEGENERATE_BASES} />
                </h4>
                {StandardDegenerateBases}
              </Grid>
            ) : (
              ''
            )}
            {uracilAndInosine.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_URACLI_INOSINE} />
                </h4>
                {uracilAndInosine}
              </Grid>
            ) : (
              ''
            )}

            {lnaBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_LNA_BASES} />
                </h4>
                {lnaBases}
              </Grid>
            ) : (
              ''
            )}

            {modifiedBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_MODIFIED_BASES} />
                </h4>
                {modifiedBases}
              </Grid>
            ) : (
              ''
            )}

            {DNABases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_DNA_BASES} />
                </h4>
                {DNABases}
              </Grid>
            ) : (
              ''
            )}

            {RnaDegenerateBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_RNA_DEGENERATE_BASES} />
                </h4>
                {RnaDegenerateBases}
              </Grid>
            ) : (
              ''
            )}

            {TwoOMeRNABases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_OME_RNA_BASES} />
                </h4>
                {TwoOMeRNABases}
              </Grid>
            ) : (
              ''
            )}
            {twoFluoroBases.length ? (
              <Grid item xs={12} sm={4}>
                <h4 className={classes.subHead}>
                  <FormattedMessage {...messages.CONF_FLUORO_BASES} />
                </h4>
                {twoFluoroBases}
              </Grid>
            ) : (
              ''
            )}
          </>
        )}
      </Grid>
    </>
  )
}

export default OptionalBases
